import useAppContext from 'flow/hooks/useAppContext';
import React, { useRef } from 'react';
import RemoveAttachmentButton from './RemoveAttachmentButton';
import Icon from 'flow/components/ui-components/Icon';

interface Props {
    imageSrc: string;
    removeAttachment: () => void;
    addAttachment: (e: React.ChangeEvent<HTMLInputElement>) => void;
}
const ImagePicker = ({ imageSrc, removeAttachment, addAttachment }: Props) => {
    const { i18next } = useAppContext();
    const fileInputRef = useRef<HTMLInputElement>(null);

    return imageSrc ? (
        <div className="relative">
            <img
                src={imageSrc}
                alt={i18next.t('preview')}
                className="max-h-[320px] min-h-40 w-full rounded-sm object-cover"
            />
            <div className="bg-gray-150 absolute end-2 top-2 flex size-8 items-center justify-center rounded-full border-2 border-gray-500 text-gray-600 hover:bg-gray-300">
                <RemoveAttachmentButton
                    handleRemoveAttachment={removeAttachment}
                />
            </div>
        </div>
    ) : (
        <div className="flex min-h-[320px] items-center justify-center gap-x-3 rounded-sm bg-gray-200">
            <button
                aria-label={i18next.t('Chat.Tooltip.Image')}
                onClick={() => fileInputRef.current.click()}
            >
                <div className="hover:darken-10 flex size-9 items-center justify-center rounded-full bg-gray-300 p-1 text-gray-500 hover:text-gray-700">
                    <Icon
                        className="size-4"
                        iconKey={'addPhotoAlternateIcon'}
                    />
                    <input
                        ref={fileInputRef}
                        type="file"
                        className="hidden"
                        onChange={(e) => addAttachment(e)}
                        accept="image/*"
                    />
                </div>
            </button>
            <p className="text-sm font-medium">
                {i18next.t('Chat.Tooltip.Image')}
            </p>
        </div>
    );
};

export default ImagePicker;
